import styled from 'styled-components';
import TripToolIconBase from '#/shared/components/TripToolIcon';
import {
  DESKTOP_MIN_BREAK,
  PHONE_BREAK,
  TABLET_BREAK,
  TOP_BORDER_RADIUS,
} from '#/shared/constants';
import { ClearGatsbyLink } from '#/shared/components/Styled';
import tabSharedCss from '#/shared/css/tab';

export const TripToolIcon = styled(TripToolIconBase)`
  width: 35px;
  height: 35px;
  fill: ${props =>
    props.$active ? props.theme.tabActiveColor : props.theme.tabColor};
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    width: 30px;
    height: 30px;
  }
`;

export const Tab = styled(ClearGatsbyLink)`
  min-width: 0;
  padding: 12px 2px;
  text-decoration: none;
  flex: 1 1 25%;
  text-align: center;
  cursor: pointer;
  background-color: ${props => props.theme.tabBackgroundColor};
  -webkit-tap-highlight-color: transparent;
  pointer-events: initial;

  ${({ 'aria-current': active, theme }) =>
    tabSharedCss({ active: !!active, theme })};

  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.tabBackgroundColor};
      color: ${props => props.theme.tabActiveColor};
      ${TripToolIcon} {
        fill: ${props => props.theme.tabActiveColor};
      }
    }
  }

  &:focus,
  &:active {
    background-color: ${props => props.theme.tabBackgroundColor};
  }
`;

export const TabList = styled.nav`
  box-shadow: ${props => props.theme.boxShadowPanel};
  visibility: ${({ minimized }) => (minimized ? 'hidden' : 'visible')};
  display: flex;
  max-width: ${DESKTOP_MIN_BREAK};
  align-items: center;
  background-color: ${props => props.theme.mainColor};
  border-radius: ${TOP_BORDER_RADIUS};
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    ${Tab} {
      border-radius: ${TOP_BORDER_RADIUS};
    }
  }
`;

export const TabIconRow = styled.div`
  position: relative;
  padding: 1px 0;
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    padding: 3px 0;
  }
`;

export const TabName = styled.div`
  font-size: 1rem;
  margin-top: -5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  @media (min-width: ${PHONE_BREAK}) {
    font-size: 1.1rem;
    margin-top: -3px;
  }
  @media (min-width: ${TABLET_BREAK}) {
    font-size: 1.4rem;
  }
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    font-size: 1.2rem;
  }
`;

export const AlertNotificationDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.theme.dangerColor};
  border: 1.5px solid ${props => props.theme.white};
  position: absolute;
  top: calc(50% - 5px);
  right: calc(50% - 10px);
  transform: translate(50%, -50%);
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    width: 12px;
    height: 12px;
  }
  @media (forced-colors: active) {
    background-color: currentColor;
  }
`;
